import { useMap } from '@vis.gl/react-google-maps';

export function useIsVectorMap() {
  const map = useMap();
  return map?.getRenderingType() === 'VECTOR';
}
